exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".index__app-wrapper___1mCr_{box-sizing:border-box;min-height:100vh;margin:0;padding:0;overflow:hidden}", ""]);

// exports
exports.locals = {
	"app-wrapper": "index__app-wrapper___1mCr_"
};